/**
 * Procedure Categories and Procedures for MD in Community Medicine students
 * Extracted with strict evidence from official NMC PDF
 */
export const COMMUNITY_MEDICINE_PROCEDURES = {
  "Field & Clinical Interventions": [
    "Incision and Drainage of Abscesses",
    "Wound Dressing & Injection Administration",
    "Intrauterine Contraceptive Device (Copper-T / IUCD) Insertion",
    "Pap Smear Preparation & Cervical Screening",
  ],
  "Environmental & Public Health Interventions": [
    "Horrock's Apparatus Water Chlorine Demand Test & Water Tank Chlorination",
    "Biological & Hospital Waste Collection, Segregation, and Disinfection",
    "Occupational Exposure & Environmental Hazard Measurement",
  ],
};

export const COMMUNITY_MEDICINE_CATEGORIES = Object.keys(COMMUNITY_MEDICINE_PROCEDURES);

export const isMDInCommunityMedicineDept = (department) => {
  if (!department) {
    try {
      const u = JSON.parse(
        localStorage.getItem("userData") || localStorage.getItem("user") || "{}"
      );
      department = u.department || (u.departments && u.departments[0]);
    } catch (e) {}
  }
  if (!department) return false;
  const d = String(department).toLowerCase();
  return (
    d.includes("community medicine") ||
    d.includes("psm") ||
    d.includes("preventive and social medicine") ||
    d.includes("public health")
  );
};
